import React from 'react'
import Panel from 'muicss/lib/react/panel'
import Container from 'muicss/lib/react/container'
import Col from 'muicss/lib/react/col'
import RaisedButton from 'material-ui/RaisedButton'
import Form from 'muicss/lib/react/form'
import { TextField } from 'redux-form-material-ui'
import { reduxForm, Field } from 'redux-form'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import './style.css'
import { login } from '../../actions'
import { recovery_password_path } from '../../routes'

/* Vista*/
class Login extends React.Component {

  render() {
    return (
      <Container>
        <Col xs={12} md-offset={3} md={6} >
          <Panel className="modal-panel">
            <Form onSubmit={this.props.handleSubmit(this.props.login)}>
              <legend>Login</legend>
              <Field name="email" label="Email" component={TextField} fullWidth floatingLabelText="Email" type="email" />
              <Field name="password" component={TextField} fullWidth floatingLabelText="Contraseña" type="password" />
              <br />
              <br />
              <div style={{ textAlign: 'center' }}>
                <RaisedButton type="submit" label="Iniciar Sesión" primary style={{ textAlign: 'center' }} />
              </div>
            </Form>
            <Link to={recovery_password_path()} onClick={this.props.toggleSidebar}>
              Recuperar Constraseña
            </Link>
          </Panel>
        </Col>
      </Container>
    )
  }
}
/* Lógica*/

Login.propTypes = {
  handleSubmit: React.PropTypes.func.isRequired,
  login: React.PropTypes.func.isRequired,
}


const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  login: values => dispatch(login(values)),
})

const ReduxLogin = connect(mapStateToProps, mapDispatchToProps)(Login)

export default reduxForm({
  form: 'LoginForm',
})(ReduxLogin)




// WEBPACK FOOTER //
// ./src/components/Login/index.jsx